import React from 'react';
import { Building2 } from 'lucide-react';

function TabGeneral({ configuracion }) {
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3 mb-6">
        <Building2 size={24} className="text-ink-700" />
        <div>
          <h2 className="text-xl font-semibold text-ink-900">Configuración General</h2>
          <p className="text-sm text-ink-500">Información de la empresa y preferencias regionales</p>
        </div>
      </div>

      <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 text-center">
        <p className="text-blue-800 font-medium">Pestaña en desarrollo</p>
        <p className="text-sm text-blue-600 mt-2">Aquí podrás configurar información corporativa, zona horaria y preferencias de UI</p>
      </div>
    </div>
  );
}

export default TabGeneral;
